import React from 'react';
import { trackNavigation, trackUIInteraction } from '../../utils/gtm';
import AppHeader from '../layout/AppHeader';
import Icon from './Icon';

/**
 * Game Header Component
 * Single Responsibility: Rendering game header with navigation and settings
 */
const GameHeader = ({ 
  openingName, 
  playerColor, 
  soundEnabled, 
  onBack, 
  onSoundToggle 
}) => {
  return (
    <AppHeader
      right={
        <button
          onClick={() => {
            trackUIInteraction('sound_toggle', 'click', soundEnabled ? 'disable' : 'enable');
            onSoundToggle();
          }}
          className="btn-ghost btn-icon"
          title={soundEnabled ? 'Mute sounds' : 'Enable sounds'}
          aria-pressed={soundEnabled}
        >
          <Icon name={soundEnabled ? 'volume' : 'volumeOff'} size={18} />
        </button>
      }
    >
      <button 
        onClick={() => {
          trackNavigation('back_to_courses', openingName || 'unknown', 'homepage');
          onBack();
        }}
        className="btn-ghost btn-icon"
        title="Back to courses"
      >
        <Icon name="arrowLeft" size={18} />
      </button>
      <h1 className="text-sm sm:text-base font-bold text-ink-100 truncate">
        {openingName || 'Unknown Opening'}
      </h1>
      <span className="hidden sm:inline-flex badge bg-ink-750 text-ink-300 flex-shrink-0" title="Your piece color">
        <span className={`w-2.5 h-2.5 rounded-full ring-1 ${playerColor === 'white' ? 'bg-ink-100 ring-ink-300' : 'bg-ink-950 ring-ink-500'}`} />
        {playerColor === 'white' ? 'White' : 'Black'}
      </span>
    </AppHeader>
  );
};

export default GameHeader;
